// extracted by mini-css-extract-plugin
export default {"component":"b3yLIj","pinIcon":"c3yLIj","label":"d3yLIj","text":"e3yLIj","link":"f3yLIj"};